import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translateStatus',
})
export class translateStatusPipe implements PipeTransform {
  private translations: { [key: string]: string } = {
    'New': 'Новый',
    'Cancelled': 'Отменён',
    'AwaitConfirmation': 'Ожидает подтверждения',
    'Confirmed': 'Подтверждён',
    'Paid': 'Оплачен',
    'InProcessing': 'Принят в работу',
    'Pickup': 'Готов к выдаче',
    'Delivery': 'Принят в доставку',
    'Completed': 'Исполнен',
    'Delivered': 'Доставлен',
    'Refunded':'Возвращен',
  };

  transform(value: string): string {
    return this.translations[value] || value;
  }
}
